module.exports = __webpack_public_path__ + "img/icon27.f439e5a9.png";